var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoneGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 .667C17.877.667.665 17.878.665 39c0 21.121 17.212 38.333 38.333 38.333 21.122 0 38.334-17.212 38.334-38.333C77.333 17.878 60.12.667 38.999.667zm18.323 29.516L35.588 51.918a2.872 2.872 0 0 1-4.064 0L20.676 41.07a2.892 2.892 0 0 1 0-4.063 2.892 2.892 0 0 1 4.063 0l8.817 8.816L53.259 26.12a2.892 2.892 0 0 1 4.064 0c1.111 1.111 1.111 2.913 0 4.063z",
    fill: "#08C56A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneGreen);
export default __webpack_public_path__ + "static/media/done-green.d77aa51bc491142f2a0b6f53b5d2373a.svg";
export { ForwardRef as ReactComponent };